import { Injectable } from '@angular/core';

import { environment } from '../objects/environment';

@Injectable()
export class Environment_Service {
    public environment: environment = new environment();
}
